/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 演出项目是否需要滑块
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/project/captcha/${productId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
